import { render, staticRenderFns } from "./head.vue?vue&type=template&id=5128bf7c&scoped=true&"
import script from "./head.vue?vue&type=script&lang=js&"
export * from "./head.vue?vue&type=script&lang=js&"
import style0 from "./head.vue?vue&type=style&index=0&id=5128bf7c&lang=scss&scoped=true&"
import style1 from "./head.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128bf7c",
  null
  
)

export default component.exports